import { render, staticRenderFns } from "./PreviewLinkInBio.vue?vue&type=template&id=dc790c0a"
import script from "./PreviewLinkInBio.vue?vue&type=script&lang=js"
export * from "./PreviewLinkInBio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports